var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlanOnboarding1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 56,
    r: 42,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.031 34.648h-1.856a.98.98 0 0 0-.975.975v6.994H36.8v-6.994a.98.98 0 0 0-.975-.975h-1.866A4.96 4.96 0 0 0 29 39.608v32.784c0 2.381 2.119 4.969 5.063 4.969h37.865c2.944 0 5.072-2.55 5.072-4.969V39.608c0-2.738-2.231-4.96-4.969-4.96m-41.072 4.96a3.01 3.01 0 0 1 3-3.01h.882v30.825h-.882a4.93 4.93 0 0 0-3 1.022zm43.979 32.794a3.013 3.013 0 0 1-3.01 3.009H34.063a3.007 3.007 0 0 1-3.01-3.01v-.74a3 3 0 0 1 2.906-2.269h1.857a.974.974 0 0 0 .975-.975v-23.84h32.4v23.83c0 .545.44.976.975.976h1.865c1.397 0 2.569.956 2.906 2.25zm.103-3.947a4.96 4.96 0 0 0-3.01-1.022h-.881V36.608h.881c1.66 0 3.01 1.35 3.01 3.01z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.95 48.5H42.256a2.76 2.76 0 0 0-2.756 2.756v15.14a2.76 2.76 0 0 0 2.756 2.757h2.053a.974.974 0 1 0 0-1.95h-2.053a.796.796 0 0 1-.797-.797v-10.21h2.25a.974.974 0 1 0 0-1.95h-2.25v-2.98c0-.441.357-.797.797-.797h11.016v3.778h-5.194a.974.974 0 1 0 0 1.95h6.178c.544 0 .975-.44.975-.975v-4.763h8.719c.44 0 .797.357.797.797v7.36h-10.5a.974.974 0 1 0 0 1.95h10.5v5.822c0 .44-.356.796-.797.796h-8.719v-1.837a.974.974 0 1 0-1.95 0v1.837h-2.334l-1.36-2.84a.975.975 0 0 0-1.303-.46.975.975 0 0 0-.459 1.303l1.622 3.404c.16.337.506.553.881.553H63.96a2.76 2.76 0 0 0 2.757-2.757v-15.13A2.775 2.775 0 0 0 63.95 48.5",
    fill: "#E5A033"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4050_20244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4050_20244",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlanOnboarding1);
export default __webpack_public_path__ + "static/media/ic_plan_onboarding_1.699196e57a76e705ab343683fad3d08d.svg";
export { ForwardRef as ReactComponent };